import React, { useState } from "react";
import './items.css'

import { BiCaretLeftCircle, BiCaretRightCircle } from "react-icons/bi";

import { listaProdutos } from "../Lista";

function Items() {


    const [itensPerPage, setItensPerPage] = useState(4)
    const [currentPage, setCurrentPage] = useState(0)

    const pages = Math.ceil((listaProdutos.length / itensPerPage) - 1)

    const startIndex = currentPage * itensPerPage;
    const endIndex = startIndex + itensPerPage;
    const currentLista = listaProdutos.slice(startIndex, endIndex)

    console.log(pages)
    // console.log(currentPage)

    function proximoItem() {
        if (currentPage == pages) {
            alert('Você estar na ultima página')
            return
        }
        setCurrentPage(currentPage + 1)
    }

    function anteriorItem() {
        if (currentPage == 0) {
            alert('Você estar na primeira página')
            return
        }
        setCurrentPage(currentPage - 1)
    }

    // implementanndo numeração
    {/* <div>
                {Array.from(Array(pages), (item, index) => {
                    return <button value={index} onClick={(e) => setCurrentPage(Number(e.target.value))} >{index}</button>
                })}
            </div> */}

    return (
        <div className="geral">
            <div className="containerItems">
                {currentLista.map((item) => {
                    return (

                        <div>
                            <div className="divAjustar">
                                <div className="divCoca">
                                    <img src={item.img} />
                                </div>
                                <div className="items1">
                                    <div>
                                        <small>{item.nome}</small>
                                    </div>
                                    <br></br>
                                    <div className="items2">
                                        <small style={{ fontSize: '13px', color: 'grey' }}>R$</small>
                                        <small style={{ fontSize: '25px', color: 'grey' }}>{(item.preco).toFixed(2)}</small>
                                    </div>
                                </div>
                            </div>
                            <div className="divButton">
                                <button onClick={() => alert('Item adicionado')}>COMPRE AGORA </button>
                            </div>
                        </div>
                    )
                })}
            </div>
            <div className="divSetas">
                <BiCaretLeftCircle size={30} color='yellow' className="icon" onClick={anteriorItem} />
                <BiCaretRightCircle size={30} color='yellow' onClick={proximoItem} />
            </div>

        </div>
    )


}

export default Items;